document.addEventListener('DOMContentLoaded', (event) => {
  gsap.registerPlugin(ScrollTrigger);

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.section-values',
      pin: '.section-values',
      end: `+=${window.innerHeight * 1.8}`,
      start: 'top top',
      scrub: 0.5,
      snap: 'labelsDirectional',
      toggleClass: { targets: 'body', className: 'navbar--hide--' },
    },
  });

  const values = document.querySelectorAll('.sv-value');

  values.forEach((value, index) => {
    const prevValue = values?.[index - 1];

    if (prevValue) {
      tl.to(prevValue, {
        y: -140,
        ease: 'none',
        duration: 1,
      });
      tl.to(
        prevValue,
        {
          autoAlpha: 0,
          ease: 'none',
          duration: 0.6,
          delay: 0.4,
        },
        '<',
      );
    }

    if (index !== 0) {
      tl.fromTo(
        value,
        {
          y: 140,
        },
        {
          y: 0,
          ease: 'none',
          duration: 1,
        },
      );
      tl.fromTo(
        value,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          ease: 'none',
          duration: 0.6,
        },
        '<',
      );
    }

    tl.add(`slide-${index}`);

    if (index !== values.length - 1) {
      tl.to(value, {
        y: -30,
        duration: 0.5,
        ease: 'none',
      });
    }
  });
});
